<template>
  <div v-if="res" class="activity-bottom-component">
    <div v-if="typeRes !== 'guide'" class="no-guide">
      <!-- 切换支付按钮 -->
      <div
        v-if="typeRes === 'final_payment'"
        class="switch-btn"
        @click="changePayPattern"
      >
        <div v-if="isWechat" class="pattern">
          <img class="pattern-pic" src="../assets/wechat.png" alt />
          <span class="pattern-desc">微信支付</span>
        </div>
        <div v-else class="pattern">
          <img class="pattern-pic" src="../assets/alipay.png" alt />
          <span class="pattern-desc">支付宝</span>
        </div>
        <div class="switch">
          <img class="switch-pic" src="../assets/switch.png" alt />
        </div>
      </div>
      <!-- 倒计时 -->
      <div v-if="topRes" class="prompts">
        <div v-if="topRes && topRes.desc" class="prompts-desc">
          {{ topRes.desc }}
        </div>
        <div class="prompts-times">
          <span class="prompts-day">{{ day }}天{{ hr }}小时</span>
          <span class="times-item">{{ min }}分{{ sec }}秒</span>
        </div>
      </div>
      <!-- 剩余名额 -->
      <div v-if="parseInt(res.remain) < 1000" class="remain">
        剩余名额{{ res.remain }}个
      </div>

      <!-- 支付定金 -->
      <div v-if="typeRes === 'perpay'" class="prepay">
        <div class="prepay-desc">
          <div class="price-wrap">
            <div v-if="res.countdown_desc" class="countdown-desc">
              {{ res.countdown_desc }}
            </div>
            <div v-if="res.del_price" class="delete-price">
              原价{{ res.del_price }}
            </div>
          </div>
          <div v-if="res.desc" class="desc">{{ res.desc }}</div>
        </div>

        <div
          class="btn"
          :class="{
            disabled:
              res.button_disable || parseInt(res.remain) <= 0 || isClicked,
          }"
          @click="payHandle"
        >
          {{ buttonDescRes }}
        </div>
      </div>

      <!-- 支付尾款 -->
      <div v-if="typeRes === 'final_payment'" class="final-payment">
        <div class="final-desc">
          <div class="price-wrap">
            <div class="act-price">
              <i class="symbol">¥</i>
              {{ res.price }}
            </div>
            <div class="origin-price">原价{{ res.origin_price }}</div>
          </div>
          <div class="tag-wrap">
            <div class="first-tag">
              <div class="first-item">{{ res.tag[0] }}</div>
            </div>
            <div class="second-tag">
              <div class="second-item">{{ res.tag[1] }}</div>
            </div>
            <div class="countdown-desc">
              <div class="countdown-item">{{ res.countdown_desc }}</div>
            </div>
          </div>
        </div>
        <div
          class="btn"
          :class="{
            disabled:
              res.button_disable || parseInt(res.remain) <= 0 || isClicked,
          }"
          @click="payHandle"
        >
          {{ buttonDescRes }}
        </div>
      </div>
    </div>

    <!-- 上课指引 -->
    <div v-if="typeRes === 'guide'" class="guide" @click="guideHandle">
      {{ buttonDescRes }}
      <img class="guide-pic" src="../assets/guide.png" />
    </div>

    <!-- 网络错误弹窗 -->
    <transition name="fade">
      <div v-if="isShowToast" class="toast">
        <img class="toast-pic" src="../assets/wifi.svg" alt />
        <span class="toast-desc">网络不可用</span>
      </div>
    </transition>
  </div>
</template>

<script>
import { throttle } from '@lib/util';
import pingpp from 'pingpp-js';
import { setCookie, getCookie, getQueryFromSearch } from '@/lib/util.ts';
import { CHARGE_ID, TIME_RECORD_BEGIN, COUNT_DOWN, EXPIRES } from '../types';
import { setInterval, clearInterval } from 'timers';
import trackerLoaded, { patchTracker } from '@lib/tracker';
import qs from 'querystring';

export default {
  props: {
    res: {
      type: Object,
      default: null,
    },
    topRes: {
      type: Object,
      default: null,
    },
    isClicked: {
      type: Boolean,
      default: false,
    },
    sensor: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isShowToast: false,
      chargeConfig: null,
      msec: 0, // 时间戳
      day: 0, // 天
      hr: 0, // 时
      min: 0, // 分
      sec: 0, // 秒
      timeInterval: null, // 定时器
      isWechat: true,
      aliPayUrl: '',
    };
  },
  computed: {
    typeRes() {
      if (this.res && this.res.type) {
        return this.res.type;
      }
      return '';
    },
    buttonDescRes() {
      if (this.res && this.res.button_desc) {
        return this.res.button_desc;
      }
      return '';
    },
  },
  watch: {
    topRes(newVal, oldVal) {
      if (newVal && newVal.timestamp) {
        this.msec = newVal.timestamp;
      }
    },
  },
  created() {
    if (this.topRes && this.topRes.timestamp) {
      this.msec = this.topRes.timestamp;
    }
    this.counter();
    this.timeInterval = setInterval(this.counter, 1000);
  },
  destroyed() {
    clearInterval(this.timeInterval);
  },
  methods: {
    guideHandle() {
      if (this.res && this.res.url) {
        window.location.href = this.res.url;
      }
    },
    async payHandle() {
      if (parseInt(this.res.remain) <= 0) {
        return;
      }
      if (this.res && this.res.button_disable) {
        return;
      }
      if (this.isClicked) {
        return;
      }
      const { From, FromVersion } = this.$route.query;
      // 支付定金埋点
      if (this.typeRes === 'perpay') {
        trackerLoaded.then((tracker) => {
          patchTracker(tracker).track('ButtonClick', {
            tracking_scene: '618活动报名页',
            tracking_subscene: '支付定金',
            production_id: Number(this.sensor.production_id),
            production_type: this.sensor.production_type,
            original_price: Number(this.sensor.original_price),
            button_name: '支付定金',
            button_type: '普通按钮',
            from: From || 'unknown',
            from_version: FromVersion || 'unknown',
          });
        });
      } else if (this.typeRes === 'final_payment') {
        // 支付尾款埋点
        trackerLoaded.then((tracker) => {
          patchTracker(tracker).track('ButtonClick', {
            tracking_scene: '618活动报名页',
            tracking_subscene: '支付尾款',
            production_id: Number(this.sensor.production_id),
            production_type: this.sensor.production_type,
            original_price: Number(this.sensor.original_price),
            button_name: '立即付尾款',
            button_type: '普通按钮',
          });
        });
      }
      if (this.isWechat) {
        await this.initChargeConfig();
        this.pingppToWechat();
        this.$emit('sendGetChargeStatusReq');
      } else {
        // 获取支付宝url
        this.getUrl();
      }
    },
    async getUrl() {
      const jwt = getCookie('token');
      const res = await window.apis
        .getAliPayUrl(
          {},
          {
            token: jwt,
            id: parseInt(this.res.production_id),
            ...this.$route.query,
          }
        )
        .catch((e) => {
          if (!e.status) {
            this.isShowToast = true;
            setTimeout(() => {
              this.isShowToast = false;
            }, 1600);
          }
        });

      this.aliPayUrl = res.data.pay ? encodeURIComponent(res.data.pay) : '';

      const payUrl =
        window.location.origin +
        window.location.pathname.replace(/\d+$/, '') +
        'pay/proxy';
      window.location.href = payUrl + `?alipayurl=${this.aliPayUrl}`;
    },
    initChargeConfig() {
      const searchQuery = getQueryFromSearch();
      return window.apis
        .getActivityChargeReq({
          id: parseInt(this.res.production_id),
          ...this.$route.query,
          ...searchQuery,
        })
        .then((res) => {
          const {
            data: { charge },
          } = res;
          this.chargeConfig = charge;
          this.chargeId = charge.id;
          setCookie(CHARGE_ID, this.chargeId, EXPIRES);
          return charge;
        })
        .catch((e) => {
          console.log('>>>>>>>', e.status);
          if (!e.status) {
            this.isShowToast = true;
            setTimeout(() => {
              this.isShowToast = false;
            }, 1600);
          }
        });
    },
    pingppToWechat() {
      return pingpp.createPayment(this.chargeConfig, (result, err) => {
        console.log(result);
        if (result === 'success') {
          console.log('创建支付成功');
        } else if (result === 'fail') {
          console.log('失败');
        } else if (result === 'cancel') {
          console.log('cancel');
        }
      });
    },
    counter() {
      if (this.msec) {
        this.msec = this.msec - 1000;
      }
      const day = parseInt(this.msec / 1000 / 60 / 60 / 24);
      const hr = parseInt((this.msec / 1000 / 60 / 60) % 24);
      const min = parseInt((this.msec / 1000 / 60) % 60);
      const sec = parseInt((this.msec / 1000) % 60);
      this.day = day;
      this.hr = hr > 9 ? hr : '0' + hr;
      this.min = min > 9 ? min : '0' + min;
      this.sec = sec > 9 ? sec : '0' + sec;
    },
    changePayPattern() {
      this.isWechat = !this.isWechat;
    },
  },
  beforeUpdated() {
    if (this.topRes && this.topRes.timestamp) {
      this.msec = this.topRes.timestamp;
    }
  },
};
</script>

<style lang="scss" scoped>
.activity-bottom-component {
  position: relative;
  width: 100%;

  .no-guide {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    width: 100%;

    .switch-btn {
      display: flex;
      flex-direction: row;
      width: 190px;
      overflow: hidden;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;

      .pattern {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 136px;
        height: 56px;
        background-color: #f0eef6;

        .pattern-pic {
          width: 21.1px;
          height: 21.1px;
        }

        .pattern-desc {
          margin-left: 7px;
          color: rgba(59, 53, 97, 0.41);
          font-size: 20px;
        }
      }

      .switch {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 54px;
        height: 56px;
        background-color: #e3e2e9;

        .switch-pic {
          width: 22.6px;
          height: 23.2px;
        }
      }
    }

    .prompts {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100vw;
      height: 56px;
      padding: 0 25px;
      background-color: #ffe1ed;

      .prompts-desc {
        color: #b66083;
        font-size: 22px;
      }
      .prompts-times {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        .prompts-day {
          color: #b66083;
          font-size: 22px;
        }
        .times-item {
          margin-left: 10px;
          color: #f02b3a;
          font-weight: 600;
          font-size: 28px;
        }
      }
    }
    .remain {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 56px;
      color: #ffffff;
      font-size: 28px;
      background-image: linear-gradient(to left, #ff4458, #ff8b4d);
    }
    .prepay {
      z-index: 10;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      box-sizing: content-box;
      padding: 9px 10px;
      padding-bottom: calc(9px + constant(safe-area-inset-bottom));
      padding-bottom: calc(9px + env(safe-area-inset-bottom));
      background-color: #fff;

      .prepay-desc {
        display: flex;
        flex-direction: column;
        margin-left: 12px;

        .price-wrap {
          display: flex;
          flex-direction: row;
          align-items: center;

          .countdown-desc {
            margin-right: 11px;
            color: #3b3561;
            font-weight: 600;
            font-size: 24px;
            line-height: 1.92;
          }
          .delete-price {
            position: relative;
            color: rgba(59, 53, 97, 0.41);
            font-weight: 600;
            font-size: 24px;

            &::before {
              position: absolute;
              top: 18px;
              left: 0;
              display: block;
              width: 100px;
              height: 2px;
              background-color: rgba(164, 163, 185, 0.76);
              transform: rotate(-3deg);
              content: '';
            }
          }
        }
        .desc {
          margin-top: 3px;
          color: #f02b3a;
          font-weight: 500;
          font-size: 22px;
        }
      }
      .btn {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 330px;
        height: 90px;
        margin-left: 16px;
        color: #ffffff;
        font-size: 40px;
        background-image: linear-gradient(277deg, #ff2978, #b046ff);
        border-radius: 8px;
      }
      .disabled {
        opacity: 0.4;
      }
      .unClicked {
        opacity: 0.4;
      }
    }
    .final-payment {
      z-index: 10;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      box-sizing: content-box;
      padding: 15.5px 10px;
      padding-bottom: calc(15.5px + constant(safe-area-inset-bottom));
      padding-bottom: calc(15.5px + env(safe-area-inset-bottom));
      background-color: #fff;

      .final-desc {
        display: flex;
        flex-direction: row;

        .price-wrap {
          display: flex;
          flex-direction: column;

          .act-price {
            margin-top: 14.5px;
            color: #3b3561;
            font-weight: 600;
            font-size: 60px;
            line-height: 0.77;
            .symbol {
              margin-right: 6px;
              font-size: 34px;
            }
          }
          .origin-price {
            position: relative;
            margin-top: 16px;
            margin-left: 23px;
            color: rgba(59, 53, 97, 0.41);
            font-size: 26px;

            &::before {
              position: absolute;
              top: 20px;
              left: 0;
              display: block;
              width: 100px;
              height: 2px;
              background-color: rgba(164, 163, 185, 0.76);
              transform: rotate(-3deg);
              content: '';
            }
          }
        }
        .tag-wrap {
          display: flex;
          flex-direction: column;
          margin-left: 10px;

          .first-tag {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            width: 185px;
            height: 37px;
            padding: 5px 0px;
            color: #ffffff;
            font-size: 20px;
            background-image: linear-gradient(to right, #ff4458, #ff8b4d);
            border-radius: 4px;
            transform: translateX(5px);
            .first-item {
              white-space: nowrap;
              transform: scale(0.8);
            }
          }
          .second-tag {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            width: 185px;
            height: 37px;
            margin-top: 4px;
            color: #ffffff;
            font-size: 20px;
            background-image: linear-gradient(267deg, #ff3da0, #ff2e56);
            border-radius: 4px;
            transform: translateX(5px);
            .second-item {
              white-space: nowrap;
              transform: scale(0.8);
            }
          }
          .countdown-desc {
            margin-top: 8px;
            color: #f02b3a;
            font-weight: 500;
            font-size: 22px;
            transform: translateX(-20px);

            .countdown-item {
              white-space: nowrap;
              transform: scale(0.8);
            }
          }
        }
      }
      .btn {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 299px;
        height: 116px;
        color: #ffffff;
        font-size: 40px;
        background-image: linear-gradient(280deg, #ff2978, #b046ff);
        border-radius: 8px;
      }
      .disabled {
        opacity: 0.4;
      }
    }
  }

  .guide {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10;
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: content-box;
    width: 100%;
    height: 108px;
    padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
    padding-bottom: env(safe-area-inset-bottom);
    padding-left: 287px;
    color: #ffffff;
    font-size: 40px;
    letter-spacing: 4px;
    background-image: linear-gradient(274deg, #ff2978, #b046ff);

    .guide-pic {
      width: 40px;
      height: 40px;
      margin-left: 223px;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 300ms;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .toast {
    position: fixed;
    top: 523px;
    left: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 320px;
    height: 180px;
    background-color: rgba(0, 0, 0, 0.75);
    border-radius: 8px;
    transform: translate(-50%, -50%);

    .toast-pic {
      width: 64px;
      height: 64px;
      margin-top: 30px;
    }
    .toast-desc {
      margin-top: 20px;
      color: #ffffff;
      font-weight: 500;
      font-size: 34px;
    }
  }
}
</style>
